// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66824a72","732":"bd47e2c1"}[chunkId] + ".chunk.js";
};